import Cookies, {CookieSetOptions} from "universal-cookie";

const cookies = new Cookies();

export function getUsernameCookie(): string {
    return cookies.get("un") ?? "";
}

export function clearUsernameCookie() {
    cookies.remove("un");
    cookies.remove("un", {path: "/", secure: true, httpOnly: false});
}

export function setCookie(name: string, value: string, options: CookieSetOptions) {
    cookies.set(name, value, options);
}

export function getAllCookies() {
    return cookies.getAll();
}
